"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Cropper = require("cropperjs");
var MAX_IMAGE_SIZE = 4000; //since iOS can't handle bigger images -> white image
var UploadDialogController = /** @class */ (function () {
    function UploadDialogController(uploads, $scope) {
        this.uploads = uploads;
        this.isModified = false;
    }
    UploadDialogController.prototype.isCropable = function () {
        return this.uploads.isCropable();
    };
    UploadDialogController.prototype.getState = function () {
        return this.uploads.current.state;
    };
    UploadDialogController.prototype.getDataUrl = function () {
        return this.uploads.current.dataUrl;
    };
    UploadDialogController.prototype.move = function (x, y) {
        var cropper = this.cropper;
        this.isModified = true;
        cropper.move(x, y);
    };
    UploadDialogController.prototype.rotate = function (deg) {
        var cropper = this.cropper;
        this.isModified = true;
        cropper.rotate(deg);
    };
    UploadDialogController.prototype.reset = function () {
        var cropper = this.cropper;
        this.isModified = false;
        cropper.reset();
        cropper.zoom(this.uploads.getCurrentOption().zoom);
    };
    UploadDialogController.prototype.save = function () {
        var cropper = this.cropper;
        var canvas = cropper.getCroppedCanvas({
            width: this.uploads.getCurrentOption().width * 2,
            fillColor: '#fff',
            maxWidth: MAX_IMAGE_SIZE,
            maxHeight: MAX_IMAGE_SIZE
        });
        if (canvas) {
            // TODO: make compression rate configurable
            var dataUrl = canvas.toDataURL('image/jpeg', 0.8);
            this.uploads.uploadImage(dataUrl);
        }
    };
    UploadDialogController.prototype.cancel = function () {
        this.uploads.cancel();
    };
    return UploadDialogController;
}());
function UploadDialogDirective(config, uploads) {
    return {
        templateUrl: config.params.base + "templates/book/upload-dialog.html",
        controller: UploadDialogController,
        controllerAs: 'uploaddialog'
    };
}
function UploadCropDirective(uploads) {
    return {
        link: function ($scope, $element) {
            var _a = uploads.getCurrentOption(), width = _a.width, height = _a.height, zoom = _a.zoom;
            var uploaddialog = $scope.$parent.uploaddialog;
            // Set minimal width of crop box to prevent user from cropping an arbitarily
            // small part of image. This ensures resulting image meets resolution requirements
            // defined in configuration.
            function setCropMinWidth(cropper, imageMinWidth, cropMinWidth) {
                var aspectRatio = cropper.options.aspectRatio;
                var image = cropper.getImageData();
                var container = cropper.getContainerData();
                // Ratio of form preview container to uploaded image (indicates form preview zoom)
                // e.g. when form is half the width of uploaded image this is 0.5.
                var formPreviewZoom = container.width / image.naturalWidth;
                // Ratio of image to container (indicates cropper zoom)
                var cropperZoom = image.width / container.width;
                // Calculate minimal crop box width, e.g. with form zoom of 0.5 minimal width must
                // not be smaller than half of the desired resulting width.
                var minCropBoxWidth = Math.max(imageMinWidth * formPreviewZoom * cropperZoom, cropMinWidth);
                cropper.cropBoxData.minWidth = minCropBoxWidth;
                cropper.cropBoxData.minHeight = minCropBoxWidth / aspectRatio;
            }
            function isClipped(cropper) {
                var image = cropper.getImageData();
                var container = cropper.getContainerData();
                var aspectNatural = image.naturalWidth / image.naturalHeight;
                var aspectPreview = container.width / container.height;
                return Math.abs(aspectNatural - aspectPreview) > 0.1;
            }
            var cropper = new Cropper($element[0], {
                aspectRatio: width / height,
                viewMode: zoom < 0 ? 0 : 2,
                dragMode: 'move',
                toggleDragModeOnDblclick: false,
                guides: false,
                center: false,
                background: false,
                zoomOnWheel: false,
                responsive: true,
                ready: function () {
                    this.cropper.isClipped = isClipped(cropper);
                    setCropMinWidth(this.cropper, width, 20);
                    // WORKAROUND: Zoom does throw error in MS Edge
                    var isIE = 
                    /*@cc_on!@*/ false || document.hasOwnProperty('documentMode');
                    var isEdge = !isIE && window.hasOwnProperty('StyleMedia');
                    if (!isEdge) {
                        cropper.zoom(zoom);
                    }
                }
            });
            cropper.replace(uploads.current.dataUrl);
            uploaddialog.cropper = cropper;
        }
    };
}
exports.UploadCropDirective = UploadCropDirective;
exports.default = angular
    .module('pb.uploadDialog', [])
    .directive('pbUploadDialog', UploadDialogDirective)
    .directive('pbUploadCrop', UploadCropDirective);
